<script setup>

</script>

<template>
<v-container>
	<v-row>
		<v-col>
			<v-card
				hover
				class="mt-16 mx-auto"
				max-width="400"
			>
				<v-card-title>
					404 Not Found
				</v-card-title>
				<v-card-text>
					Sorry, the page you are looking for could not be found.
				</v-card-text>
				<v-card-actions>
					<v-btn
						color="primary"
						to="/"
						class="w-100"
					>
						Home
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
	</v-row>
</v-container>
</template>

<style lang="scss" scoped>

</style>